var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.966,
    height: 23.792,
    viewBox: "0 0 22.966 23.792",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#6f2fd3;stroke:#6f2fd3;stroke-width:2px;}.a{stroke-miterlimit:10;}.b{stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2720.98 -1034.208)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.157,23.359a3.814,3.814,0,0,0,3.731-3.047H7.426A3.814,3.814,0,0,0,11.157,23.359Z",
    transform: "translate(2721.265 1033.641)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.814,19.745h9.173a1.912,1.912,0,0,0,1.873-1.336,1.824,1.824,0,0,0-.573-1.87A6.981,6.981,0,0,1,18.8,11.194V8.29A7.29,7.29,0,0,0,11.511,1c-.236,0-.468.013-.7.036h1.3c-.23-.023-.461-.036-.7-.036a7.29,7.29,0,0,0-7.29,7.29v2.9a6.985,6.985,0,0,1-2.487,5.345,1.822,1.822,0,0,0-.573,1.87,1.91,1.91,0,0,0,1.872,1.336h7.877Z",
    transform: "translate(2721.001 1034.208)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationActiveIcon);
export default __webpack_public_path__ + "static/media/notificationActiveIcon.faba441996cdd215c3add660274d4d30.svg";
export { ForwardRef as ReactComponent };